var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.960901L6.94257 3.32836L7.05557 3.5138L7.26821 3.55781L10.0266 4.12878L8.15973 6.12594L8.00372 6.29284L8.02778 6.52004L8.31276 9.21044L5.69409 8.1074L5.5 8.02564L5.30591 8.1074L2.68724 9.21044L2.97222 6.52004L2.99628 6.29284L2.84027 6.12594L0.973385 4.12878L3.73179 3.55781L3.94443 3.5138L4.05743 3.32836L5.5 0.960901Z",
    fill: "#F3F4F6",
    stroke: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 5.5,
    y1: 0,
    x2: 5.5,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2994A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmpty);
export default __webpack_public_path__ + "static/media/star_empty.fa410d3b3331ab81e12f0bcb1d95af9a.svg";
export { ForwardRef as ReactComponent };